interface permissions_type {
    [key: string]: permission_in_roles_array | permission_in_roles_number;
}

export interface permission_in_roles_array {
    [key: string]: Int32Array | undefined;
}

export interface permission_in_roles_number {
    [key: string]: number;
}

// 用 Int32Array 和 number 定義各權限，較節省記憶體
// 0 = 全部禁止，1 = 全部允許，2 = 僅自己的 cluster, 3 = 僅自己的 workspace, 4 = 僅自己的 namespace

export const permissions: permissions_type = {
    clusters: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([0, 1, 1, 1]),
        clusterAdmin: new Int32Array([0, 0, 0, 2]),
        clusterOwner: new Int32Array([0, 0, 0, 2]),
        workspaceOwner: new Int32Array([0, 0, 0, 0]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0])
    },
    workspaces: {
        // [新增, 刪除, 更新, 列表, 绑定]
        globalAdmin: new Int32Array([1, 1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([0, 1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 2, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 2, 1]),
        workspaceOwner: new Int32Array([0, 0, 1, 3, 0]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0, 0])
    },
    workspace_info: {
        // 列表
        globalAdmin: 1,
        datacenterAdmin: 1,
        clusterAdmin: 2,
        clusterOwner: 2,
        workspaceOwner: 3,
        namespaceDeveloper: 0
    },
    workspacequotas: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([0, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1]),
        workspaceOwner: new Int32Array([0, 0, 0, 3]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0])
    },
    namespaces: {
        // [新增, 刪除, 更新, 列表, 绑定]
        globalAdmin: new Int32Array([1, 1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 2, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 2, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 3, 1]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 4, 0])
    },
    namespacequotas: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 1])
    },
    helm_chart: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([1, 1, 1, 1])
    },
    monitor: {
        // 列表
        globalAdmin: 1,
        datacenterAdmin: 1,
        clusterAdmin: 2,
        clusterOwner: 2,
        workspaceOwner: 3,
        namespaceDeveloper: 4
    },
    logging: {
        // 列表
        globalAdmin: 1,
        datacenterAdmin: 1,
        clusterAdmin: 2,
        clusterOwner: 2,
        workspaceOwner: 3,
        namespaceDeveloper: 4
    },
    nodes: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 2]),
        clusterOwner: new Int32Array([0, 0, 0, 2]),
        workspaceOwner: new Int32Array([0, 0, 0, 0]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0])
    },
    workloads: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([0, 1, 1, 1]),
        datacenterAdmin: new Int32Array([0, 1, 1, 1]),
        clusterAdmin: new Int32Array([0, 1, 1, 1]),
        clusterOwner: new Int32Array([0, 1, 1, 1]),
        workspaceOwner: new Int32Array([0, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 1])
    },
    role: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([0, 0, 0, 1]),
        workspaceOwner: new Int32Array([0, 0, 0, 1]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0])
    },
    rolebinding: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 0]),
        workspaceOwner: new Int32Array([0, 0, 0, 0]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0])
    },
    scale: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([1, 1, 1, 1])
    },
    user_groups: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([1, 1, 1, 1])
    },
    user_management: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([1, 1, 1, 1])
    },
    workload: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([0, 1, 1, 1]),
        datacenterAdmin: new Int32Array([0, 1, 1, 1]),
        clusterAdmin: new Int32Array([0, 1, 1, 1]),
        clusterOwner: new Int32Array([0, 1, 1, 1]),
        workspaceOwner: new Int32Array([0, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 1])
    },
    ingress: {
        // [新增, 刪除, 更新, 列表, 绑定 详情, yaml]
        globalAdmin: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        datacenterAdmin: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        clusterAdmin: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        clusterOwner: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        workspaceOwner: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0, 0, 1, 1])
    },
    resource: {
        // [新增, 刪除, 更新, 列表]
        globalAdmin: new Int32Array([1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([1, 1, 1, 1])
    },
    restartalarm: {
        // [新增, 刪除, 更新, 列表, 绑定 详情, yaml]
        globalAdmin: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        datacenterAdmin: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        clusterAdmin: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        clusterOwner: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        workspaceOwner: new Int32Array([0, 0, 0, 0, 0, 1, 1]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0, 0, 1, 1])
    },
    pvc: {
        // [新增, 刪除, 更新, 列表, 绑定 详情, yaml]
        globalAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
    },
    pv: {
        // [新增, 刪除, 更新, 列表, 绑定 详情, yaml]
        globalAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        workspaceOwner: new Int32Array([0, 0, 0, 0, 0, 0, 0]),
        namespaceDeveloper: new Int32Array([0, 0, 0, 0, 0, 0, 0]),
    },
    storage: {
        // [新增, 刪除, 更新, 列表, 绑定 详情, yaml]
        globalAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        datacenterAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        clusterAdmin: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        clusterOwner: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        workspaceOwner: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
        namespaceDeveloper: new Int32Array([1, 1, 1, 1, 1, 1, 1]),
    },

}